import type { FaireProductEntity } from "../../entity_types/product";

export const p_uqfjc4mrxe: FaireProductEntity = {
  token: "p_uqfjc4mrxe",
  type: "product",
  name: "Momma + Me Cross Necklace Set",
  brandToken: "b_6gjfy9yksc",
  brandName: "Helmsie",
  imageUrl:
    "https://cdn.faire.com/fastly/f5dfbc459357c185976748913b3856b8587af4687e42f089cd734f732c9281b6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1391e770d15390784a7e1a613a2f1dbc6d547f66781bda25cdc8987d7d2a6cae.jpeg",
    "https://cdn.faire.com/fastly/e23bc88264b430ff6245c2f98bcf732dc0b3ffc8128ed449710a84f9cde96b6f.jpeg",
    "https://cdn.faire.com/fastly/7bd86074ddba46161137f8b80d0da14baa6f072e7d7c66c4863fe13a03ed1474.jpeg",
    "https://cdn.faire.com/fastly/c620208abe577f13b4fddbaf7299be242da3a4ecc68497c08b9f8961cba466b0.jpeg",
    "https://cdn.faire.com/fastly/ec6eef5fe85927ce37ad31b9668e12b0cec96fbe640123fcc28784f85702b9ca.jpeg",
    "https://cdn.faire.com/fastly/b8509f0a7ec423f72ec1c1479c0deefec132fa81492ccec6b3091475ec456237.jpeg",
    "https://cdn.faire.com/fastly/2de94a113287879193206d9eb08c376e30e63394f27cf7eefc52fcb9fe6ad4de.jpeg",
    "https://cdn.faire.com/fastly/ed5edc9ad07ba37b3288b4c8daf0105937005c25a2359665b822cbe7e0cfc01c.jpeg",
    "https://cdn.faire.com/fastly/f55e5917a698a5f2a160af99dad3efa1e977614d335be53c9f501c4dd8060229.jpeg",
    "https://cdn.faire.com/fastly/f846225f19f3941128464e52ed9c83d340cb86d4aa66da9cf4f1f513ab9e3057.jpeg",
    "https://cdn.faire.com/fastly/7222e04ef33cb1e78419f988e25e2a8cdecc268e0e454e8ec2983287fb830f7f.jpeg",
  ],
  priceDollars: 22.5,
  description:
    'Match with your little in a modern way! Our Momma and Me sets are a favorite of mamas and littles alike. They also make great gifts!\n\nAll chains and charms are 16k gold plated and of the highest quality material. \nMama & me necklace set comes packaged on a custom, hand-painted card ready for the shelves!\n\n18” cross & 14" cross',
  tags: [],
  msrpDollars: 45,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:42.510Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
